// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d6-4";
export var closeButton = "_d6-6";
export var dismissButton = "_d6-3";
export var editImageWithAiContainer = "_d6-8";
export var imageUploadWrapper = "_d6-7";
export var misspelledWord = "_d6-5";
export var spellCheckContainer = "_d6-2";
export var spin = "_d6-1";
export var spinning = "_d6-0";